export const SET_OFFERS_DATA = 'SET_OFFERS_DATA';